module.exports = __webpack_public_path__ + "static/media/selected_anchorage_marker.fb15b7d5.svg";